(function () {
  'use strict';

  function initImageProgressBar() {
    var gallery = document.querySelector('.bls__product-images');
    if (!gallery) return;

    // Create centered bar wrapper
    var wrap = document.createElement('div');
    wrap.className = 'ig-img-bar-wrap ig-done'; // start hidden
    var fill = document.createElement('div');
    fill.className = 'ig-img-bar-fill';
    wrap.appendChild(fill);
    gallery.appendChild(wrap);

    function showBar() {
      fill.style.width = '0%';
      wrap.classList.remove('ig-done');
    }

    function setProgress(pct) {
      fill.style.width = Math.min(pct, 98) + '%';
    }

    function completeBar() {
      fill.style.width = '100%';
      setTimeout(function () { wrap.classList.add('ig-done'); }, 350);
    }

    function loadImage(img) {
      if (!img) return;

      // Already loaded — skip bar
      if (img.complete && img.naturalWidth > 0) {
        wrap.classList.add('ig-done');
        return;
      }

      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
      if (!src || src.startsWith('data:')) return;

      showBar();

      var xhr = new XMLHttpRequest();
      xhr.open('GET', src, true);
      xhr.responseType = 'blob';

      xhr.onprogress = function (e) {
        if (e.lengthComputable && e.total > 0) {
          setProgress((e.loaded / e.total) * 98);
        }
      };

      xhr.onload = function () { completeBar(); };
      xhr.onerror = function () { completeBar(); };
      xhr.onabort = function () { completeBar(); };

      xhr.send();
    }

    function getActiveImg() {
      var active = gallery.querySelector('.swiper-slide-active img');
      return active;
    }

    // MutationObserver watches for active slide class change
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (
          m.type === 'attributes' &&
          m.attributeName === 'class' &&
          m.target.classList.contains('swiper-slide-active')
        ) {
          var img = m.target.querySelector('img');
          if (img) loadImage(img);
        }
      });
    });

    var slides = gallery.querySelectorAll('.swiper-slide');
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    // Initial load
    setTimeout(function () {
      loadImage(getActiveImg());
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageProgressBar);
  } else {
    initImageProgressBar();
  }
})();
